<template>
    <div class="home-base">
        <router-view/>
        <div v-if="$route.meta.footer.show" class='common-footer-wrap'>
            <mt-tabbar v-model='home_selected' fixed class="common-footer">
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeIndex'}" id='home_index'><router-link :to="{ name: 'HomeIndex'}" class='item'><img src="../../assets/image/tab/icon_home_pre.png" class="image" v-if="$route.name=='HomeIndex'"><img v-else src="../../assets/image/tab/icon_home_nor.png" class="image" /><span class='text'>首页</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeGoodsclass'}" id='home_goodsclass'><router-link :to="{ name: 'HomeGoodsclass'}" class='item'><img src="../../assets/image/tab/icon_classify_pre.png" class="image" v-if="$route.name=='HomeGoodsclass'"><img v-else src="../../assets/image/tab/icon_classify_nor.png" class="image" /><span class='text'>分类</span></router-link></mt-tab-item>
                <!--<mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeSearch'}" id='home_search'><router-link :to="{ name: 'HomeSearch'}" class='item'><img src="../../assets/image/tab/icon_seek_pre.png" class="image" v-if="$route.name=='HomeSearch'"><img v-else src="../../assets/image/tab/icon_seek_nor.png" class="image" /><span class='text'>生态圈</span></router-link></mt-tab-item>-->
				<mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeArticleStq'}" id='home_stq'><router-link :to="{ name: 'HomeArticleStq'}" class='item'><img src="../../assets/image/tab/icon_stq_pre.png" class="image" v-if="$route.name=='HomeArticleStq'"><img v-else src="../../assets/image/tab/icon_stq_nor.png" class="image" /><span class='text'>生态圈</span></router-link></mt-tab-item>
                <!--<mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeCart'}" id='home_cart'><router-link :to="{ name: 'HomeCart'}" class='item'><img src="../../assets/image/tab/icon_shopping_pre.png" class="image" v-if="$route.name=='HomeCart'"><img v-else src="../../assets/image/tab/icon_shopping_nor.png" class="image" /><span class='text'>生态池</span><span class="icon" v-if="cartNumber > 0">{{ getCarCount }}</span></router-link></mt-tab-item>-->
				<mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeArticleStc'}" id='home_cart'><router-link :to="{ name: 'MemberNoticeList'}" class='item'><img src="../../assets/image/tab/icon_msg_pre.png" class="image" v-if="$route.name=='MemberNoticeList'"><img v-else src="../../assets/image/tab/icon_msg_nor.png" class="image" /><span class='text'>消息</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='MemberIndex'}" id='member_index'><router-link :to="{ name: 'MemberIndex'}" class='item'><img src="../../assets/image/tab/icon_mine_pre.png" class="image" v-if="$route.name=='MemberIndex'"><img v-else src="../../assets/image/tab/icon_mine_nor.png" class="image" /><span class='text'>我的</span></router-link></mt-tab-item>
            </mt-tabbar>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { cartQuantity } from '../../api/homecart'
export default {
  name: 'HomeBase',
  data () {
    return {
      home_selected: 'home_index',
      cartNumber: 0
    }
  },
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,
	  user: state => state.member.info
    }),
    getCarCount () {
      if (this.cartNumber > 0 && this.cartNumber < 100) {
        return this.cartNumber
      } else if (this.cartNumber >= 100) {
        return '99+'
      }
    }
  },
  created: function () {
    if (this.$route.query.inviter_id) {
      this.memberInviterId({ inviterId: this.$route.query.inviter_id })
    }
    this.getCartCount()	
	if (this.user) {		
		var link = window.location.href
		if(link.indexOf('inviter_id=') == -1)
		{
			if (link.indexOf('?') != -1)
			  link += '&'
			else
			  link += '?'
			
			link += 'inviter_id=' + this.user.member_id
			window.history.replaceState('', '', link)
		}
	}
  },
  methods: {
    ...mapMutations({
      memberInviterId: 'memberInviterId'
    }),
    getCartCount () {
      if (this.isOnline) {
        cartQuantity().then(res => {
          if (res) {
            this.cartNumber = res.result.cart_count
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    .item-wrap{position: relative}
    .image{
      width:1rem;
      height:1rem;
      display:block;
      margin-left:auto;
      margin-right:auto;
      margin-top:.2rem;
      margin-bottom:.2rem;
    }
    .icon {
        position: absolute;
        right: 0.8rem;
        top: 0.2rem;
        font-size:$h6;
        line-height: 0.7rem;
        width: 0.9rem;
        height: 0.7rem;
        background: #ef3338;
        border-radius: 1rem;
        text-align: center;
        color: #ffffff;
    }
</style>